module.exports = __webpack_public_path__ + "static/img/anxunu06.09e5977a.svg";